import { CartUpdateEvent } from '@theme/events';
const panels=new Set();
const milestoneLevels=new WeakMap();
const root=window.Shopify?.routes?.root||'/';
let cart=null, key=null, busy=false, refreshing=null, refreshTimer=null, noticeFrame=null;
function labels(panel){return Object.assign(JSON.parse(panel.dataset.labels),panel.dataset.reference==='true'?JSON.parse(panel.dataset.referenceLabels):{});}
function format(template,values={}){return template.replace(/{{\s*(\w+)\s*}}/g,(_,name)=>String(values[name]??''));}
function money(cents){return 'AED'+(cents/100).toLocaleString(document.documentElement.lang||'en',{maximumFractionDigits:2,minimumFractionDigits:0});}
function reward(cart){
  const allocated=(cart.cart_level_discount_applications||[]).filter(d=>String(d.title||d.code||d.key||'').toUpperCase().startsWith('UBWALLET')).reduce((sum,d)=>sum+Number(d.total_allocated_amount||0),0);
  const code=(cart.discount_codes||[]).filter(d=>d.applicable).map(d=>String(d.code||d.title||'')).find(value=>/^UBWALLET(100|200)$/i.test(value));
  const redeemed=allocated||(code?Math.min(Number(cart.total_discount||0),Number(code.match(/(100|200)$/)[1])*100):0);
  const total=cart.total_price+redeemed;
  return {redeemed,total,credit:total>=100000?200:total>=50000?100:0,otherSavings:Math.max(0,(cart.total_discount||0)-redeemed)};
}
function deadline(credit,redeemed){
  if(!key)return 0;
  let saved=localStorage.getItem(key);
  if(!saved&&credit>0){saved=String(Date.now()+900000);localStorage.setItem(key,saved);}
  return Number(saved)||0;
}
function positionNotice(){
  noticeFrame=null;
  const notice=document.querySelector('.ub-wallet-mode-notice');
  const slot=document.querySelector('#ub-wallet-notice-slot');
  if(!notice||!slot)return;
  const header=document.querySelector('#header-component');
  const rect=header?.getBoundingClientRect();
  const visible=header&&getComputedStyle(header).opacity!=='0';
  const bottom=visible?Math.max(0,Math.min(rect.bottom,window.innerHeight)):0;
  slot.style.setProperty('--ub-wallet-header-bottom',bottom+'px');
}
function schedulePosition(){if(!noticeFrame)noticeFrame=requestAnimationFrame(positionNotice);}
function renderPanel(panel){
  if(!cart)return;
  const t=labels(panel), state=reward(cart), notice=panel.dataset.mode==='notice';
  const isAED=cart.currency==='AED';
  panel.hidden=!isAED||(notice&&state.credit===0);
  if(!isAED)return;
  const progress=panel.querySelector('.ub-compact-track');
  progress.style.setProperty('--reward-progress',Math.min(100,state.total/1000)+'%');
  progress.setAttribute('aria-valuenow',String(Math.min(1000,Math.floor(state.total/100))));
  const target=state.total<30000?30000:state.total<50000?50000:100000;
  if(panel.dataset.reference==='true'){
    const visualProgress=state.total<30000?state.total/30000*16.6667:state.total<50000?16.6667+(state.total-30000)/20000*33.3333:state.total<100000?50+(state.total-50000)/50000*33.3333:100;
    progress.style.setProperty('--reward-progress',visualProgress+'%');
    progress.setAttribute('aria-valuemax','1000');
    progress.setAttribute('aria-valuenow',String(Math.min(1000,state.total/100)));
    panel.querySelector('[data-wallet-current]').textContent=money(state.total);
    panel.querySelector('[data-wallet-target]').textContent=money(target);
    panel.dataset.credit=String(state.credit);
    panel.dataset.applied=String(state.redeemed>0);
  }
  const rewardName=target===30000?t.delivery:target===50000?t.hundred:t.two_hundred;
  panel.querySelector('[data-wallet-progress-message]').textContent=state.total>=100000?t.all:format(t.add,{amount:money(Math.max(0,target-state.total)),reward:rewardName});
  const heading=panel.querySelector('[data-wallet-heading]'),live=panel.querySelector('[data-wallet-live]'),subtitle=panel.querySelector('[data-wallet-subtitle]'),clock=panel.querySelector('[data-wallet-time]'),button=panel.querySelector('[data-compact-apply]'),check=panel.querySelector('.ub-compact-wallet__check'),view=panel.querySelector('.ub-wallet-view-cart'),wallet=panel.querySelector('.ub-compact-wallet');
  const fullyApplied=state.redeemed>0&&state.redeemed>=state.credit*100;
  let expires=0,extended=false;
  try{if(state.credit>0)expires=deadline(state.credit,state.redeemed);extended=localStorage.getItem(key+':extended')==='1';}catch{panel.showError(t.storage);}
  const seconds=Math.max(0,Math.ceil((expires-Date.now())/1000));
  const extension=panel.querySelector('[data-wallet-extend]');
  wallet.hidden=false;
  wallet.classList.toggle('is-applied',fullyApplied&&(seconds>0||panel.dataset.reference==='true'));
  wallet.classList.toggle('is-locked',state.credit===0);
  panel.classList.toggle('is-expired',state.credit>0&&seconds===0);
  progress.querySelectorAll('b').forEach(marker=>marker.classList.toggle('is-reached',panel.dataset.reference==='true'?state.total>=Number(marker.dataset.threshold)*100:state.total/1000>=parseFloat(marker.style.left)));
  if(panel.dataset.reference==='true'){
    const level=state.total>=100000?3:state.total>=50000?2:state.total>=30000?1:0;
    const previous=milestoneLevels.get(panel);
    panel.dataset.milestone=String(level);
    const markers=[...progress.querySelectorAll('b')];
    markers.forEach((marker,index)=>marker.classList.toggle('is-next',index===level&&level<3));
    panel.querySelectorAll('.ub-compact-milestones>span').forEach((label,index)=>{
      label.classList.toggle('is-reached',index<level);
      label.classList.toggle('is-next',index===level&&level<3);
    });
    if(level>0&&(previous===undefined||level>previous)&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
      panel.animate([{boxShadow:'0 0 0 0 rgba(178,115,20,.25)'},{boxShadow:'0 0 0 5px rgba(178,115,20,0)'}],{duration:650,iterations:1});
      markers[level]?.animate([{boxShadow:'0 0 0 0 rgba(178,115,20,.4)'},{boxShadow:'0 0 0 7px rgba(178,115,20,0)'}],{duration:1000,iterations:2});
    }
    milestoneLevels.set(panel,level);
  }
  panel.querySelector('[data-wallet-ready-detail]').hidden=state.credit===0||seconds===0||notice||panel.dataset.mode==='drawer';
  button.hidden=true;button.disabled=true;clock.hidden=state.credit===0;check.hidden=true;view.hidden=true;live.hidden=state.credit===0;
  extension.hidden=state.credit===0||extended||seconds>120||seconds===0;extension.disabled=busy;
  extension.textContent=t.extend;
  if(state.credit===0){
    heading.textContent=t.locked;subtitle.textContent=format(t.locked_help,{amount:money(Math.max(0,50000-state.total)).replace(/^AED/,'')});live.hidden=false;
  }else{
    clock.textContent=String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');
    subtitle.textContent=panel.dataset.reference==='true'&&fullyApplied?t.claim_applied:t.claim;
    if(seconds>0||(panel.dataset.reference==='true'&&fullyApplied)){
      heading.textContent=fullyApplied?format(t.applied,{amount:state.redeemed/100}):format(t.wallet,{amount:state.credit});
      if(fullyApplied){view.href=root+'checkout';view.textContent=t.checkout_now;view.hidden=false;}
      else{button.hidden=false;button.disabled=busy;button.textContent=format(t.apply,{amount:state.credit});}
    }else{
      heading.textContent=t.expired;subtitle.textContent=t.expired_help;
      panel.querySelector('[data-compact-error]').hidden=true;
      view.href=root+'cart';view.textContent=t.view_cart;view.hidden=false;
    }
  }
  const offer=panel.querySelector('[data-wallet-offer-note]');
  offer.hidden=panel.classList.contains('is-expired')||!(state.otherSavings>0&&state.credit>0&&!fullyApplied);
  offer.textContent=format(t.offer_note,{amount:money(state.otherSavings)});
}
function renderAll(){panels.forEach(renderPanel);schedulePosition();}
function acceptCart(value){
  cart=value;
  key='unbound-wallet-checkout-v2:'+(window.Shopify?.designMode?'preview-'+window.Shopify.theme.id+':':'')+cart.token.split('?')[0];
  if(cart.item_count===0){try{localStorage.removeItem(key);localStorage.removeItem(key+':extended');}catch{}}
  renderAll();
}
async function refresh(){
  if(refreshing)return refreshing;
  refreshing=(async()=>{
    const response=await fetch(root+'cart.js');
    if(!response.ok)throw new Error('Could not refresh cart.');
    acceptCart(await response.json());
  })().catch(error=>panels.forEach(panel=>panel.showError(labels(panel).failure))).finally(()=>refreshing=null);
  return refreshing;
}
function scheduleRefresh(){clearTimeout(refreshTimer);refreshTimer=setTimeout(refresh,100);}
function extendWallet(panel,event){
  const button=event.target.closest('[data-wallet-extend]');
  if(!button||button.disabled||busy||!key||!cart)return;
  event.preventDefault();
  try{
    if(localStorage.getItem(key+':extended')==='1')return;
    const state=reward(cart);
    if(!state.credit)return;
    const expires=deadline(state.credit,state.redeemed);
    const remaining=expires-Date.now();
    if(remaining<=0||remaining>120000)return;
    localStorage.setItem(key+':extended','1');
    localStorage.setItem(key,String(expires+300000));
    renderAll();
  }catch{panel.showError(labels(panel).storage);}
}
async function applyWallet(panel,event){
  const button=event.target.closest('[data-compact-apply]');
  if(!button||button.disabled||busy)return;
  event.preventDefault();busy=true;renderAll();
  const t=labels(panel);
  panels.forEach(p=>p.querySelector('[data-compact-error]').hidden=true);
  try{
    const response=await fetch(root+'cart.js');
    if(!response.ok)throw new Error(t.failure);
    const current=await response.json();acceptCart(current);
    const state=reward(current);
    if(!state.credit||Date.now()>=deadline(state.credit,state.redeemed))return;
    const code='UBWALLET'+state.credit;
    const codes=(current.discount_codes||[]).filter(d=>d.applicable&&!String(d.code||d.title||'').toUpperCase().startsWith('UBWALLET')).map(d=>d.code);
    codes.push(code);
    const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(c=>c.dataset.sectionId).filter(Boolean))].slice(0,5);
    if(!sections.length)throw new Error(t.reopen);
    const updated=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(','),sections,sections_url:window.location.pathname})});
    const data=await updated.json();
    if(!updated.ok)throw new Error(data.description||t.failure);
    acceptCart(data);
    if(!(data.discount_codes||[]).some(d=>String(d.code||d.title||'').toUpperCase()===code&&d.applicable))throw new Error(t.combination);
    document.dispatchEvent(new CartUpdateEvent(data,'unbound-compact-wallet',{itemCount:data.item_count,source:'unbound-compact-wallet',sections:data.sections}));
    if(sections.some(id=>typeof data.sections?.[id]!=='string'))panel.showError(t.refresh);
    localStorage.setItem('unbound-wallet-draft-sync',String(Date.now()));
    if(panel.dataset.mode==='notice'||panel.dataset.mode==='product'){
      await customElements.whenDefined('cart-drawer-component');
      document.querySelector('cart-drawer-component')?.open();
    }
  }catch(error){panel.showError(error.message);}
  finally{busy=false;renderAll();}
}
class UnboundCompactWallet extends HTMLElement{
  connectedCallback(){
    panels.add(this);
    this.abort=new AbortController();
    this.addEventListener('click',event=>{extendWallet(this,event);applyWallet(this,event);},{signal:this.abort.signal});
    if(cart)renderPanel(this);else refresh();
    schedulePosition();
  }
  disconnectedCallback(){panels.delete(this);this.abort?.abort();}
  showError(message){const error=this.querySelector('[data-compact-error]');if(error){error.textContent=message;error.hidden=false;}}
}
if(!customElements.get('unbound-compact-wallet'))customElements.define('unbound-compact-wallet',UnboundCompactWallet);
document.addEventListener('cart:update',scheduleRefresh);
document.addEventListener('discount:update',scheduleRefresh);
window.addEventListener('pageshow',scheduleRefresh);
window.addEventListener('storage',event=>{if(event.key==='unbound-wallet-draft-sync')scheduleRefresh();else if(event.key===key)renderAll();});
window.addEventListener('scroll',schedulePosition,{passive:true});
window.addEventListener('resize',schedulePosition,{passive:true});
setInterval(renderAll,1000);
new MutationObserver(schedulePosition).observe(document.querySelector('#header-component')||document.documentElement,{attributes:true,attributeFilter:['data-sticky-state','style','class']});
